import {
  CheckboxUi,
  LedApi3LightDtoUiInner,
  SliderUi,
  UiType,
} from 'puffco-api-axios-client';

export type Ui = LedApi3LightDtoUiInner;

export const isSliderUI = (ui: Ui): ui is SliderUi => ui.type === UiType.Slider;

export const isCheckboxUI = (ui: Ui): ui is CheckboxUi =>
  ui.type === UiType.Checkbox;
